import { render } from "./CorePromiseSection.vue?vue&type=template&id=8151ec1c&scoped=true"
const script = {}

import "./CorePromiseSection.vue?vue&type=style&index=0&id=8151ec1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8151ec1c"]])

export default __exports__